import { render, staticRenderFns } from "./LoanOrderlist.vue?vue&type=template&id=41960863&scoped=true"
import script from "./LoanOrderlist.vue?vue&type=script&lang=js"
export * from "./LoanOrderlist.vue?vue&type=script&lang=js"
import style0 from "./LoanOrderlist.vue?vue&type=style&index=0&id=41960863&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41960863",
  null
  
)

export default component.exports